import { render } from "./CambridgeExams.vue?vue&type=template&id=3dd71d1a&scoped=true"
import script from "./CambridgeExams.vue?vue&type=script&lang=js"
export * from "./CambridgeExams.vue?vue&type=script&lang=js"

import "./CambridgeExams.vue?vue&type=style&index=0&id=3dd71d1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd71d1a"]])

export default __exports__